module.exports = __webpack_public_path__ + "img/iq.0ab76ff4.svg";